<template>
  <div
    :style="styles"
    class="m-0 p-0"
  >
    <ValidationProvider
      v-if="validation"
      :rules="validation"
      v-slot="{ errors }"
      :name="$t(label)"
    >
      <div class="dateInputWrapper form-group">
        <datepicker
          :value="value"
          :class="{'is-invalid': errors.length}"
          @selected="updateValue"
          @opened="floatLabel = true"
          @closed="floatLabel = false"
          ref="input"
          :name="label"
          :id="name"
          v-bind="datepickerParams"
          language="de"
          required
        ></datepicker>
        <img
          v-if="errors.length"
          class="error_min inputError"
          src="../../assets/icons/risk-icon.svg"
          height="18px"
          width="18px"
          alt
        />
        <span v-if="!value" class="floating-label">
          <span v-if="errors.length" class="validation-error">{{errors[0]}}</span>
          <span v-else :class="{floatLabel: floatLabel || value}">{{ $t(label) }}<span v-if="validation.includes('required')">*</span></span>
        </span>
        <img v-if="!errors.length && !value" class="error_min inputIcon" src="/assets/svg/calendar.svg" height="18px" width="18px" alt="Date" />
        <img v-else-if="value" class="inputIcon checkIcon" src="/assets/svg/check.svg" height="25px" width="25px" alt="check" />
      </div>
    </ValidationProvider>
    <div
      class="m-0 p-0"
      v-else
    >
      <div class="dateInputWrapper form-group">
        <datepicker
          :value="value"
          :class="{'is-invalid': errors.length}"
          @selected="updateValue"
          @opened="floatLabel = true"
          @closed="floatLabel = false"
          ref="input"
          :name="label"
          :id="name"
          v-bind="datepickerParams"
          required
        ></datepicker>
        <span
          :class="{floatLabel: floatLabel}"
          class="floating-label"
        >{{label}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@hokify/vuejs-datepicker";
import "@hokify/vuejs-datepicker/dist/vuejs-datepicker.css";

export default {
  name: "date-input",
  components: {
    Datepicker
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: Date
    },
    validation: {
      type: String,
      required: false
    },
    params: {
      type: Object,
      required: false
    },
    styles: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    datepickerParams () {
      const params = { ...this.params };
      console.log(new Date())
      if (params.disabledDates) {
        if (params.disabledDates.to) {
          params.disabledDates.to = this.convertToDate(params.disabledDates.to);
        }
        if (params.disabledDates.from) {
          params.disabledDates.from = this.convertToDate(
            params.disabledDates.from
          );
          params.openDate = params.disabledDates.from;
        }

      }
      return params;
    }
  },
  data () {
    return {
      floatLabel: false
    };
  },
  methods: {
    updateValue (value) {
      this.$emit("component-updated", {
        value
      });
    },
    convertToDate (date) {
      if (date === "today") {
        return new Date(Date.now());
      } else if (date === "18years") {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 18);
        return date;
      } else {
        return new Date(Date.parse(date));
      }
    }
  }
};
</script>

<style scoped lang="scss">
$medium: 800px;

.inputError {
  position: absolute;
  right: 25px;
  top: 15px;
}
.dateInputWrapper {
  position: relative;
  margin: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
  .inputIcon {
    position: absolute;
    right: 10px;
    top: 30%;
  }
  .error_min {
    width: 16px;
  }
  .checkIcon {
    top: 20%;
  }
  .inputError {
    position: absolute;
    top: 15px;
    right: 30px;
  }

  /deep/ input {
    background: transparent;
    outline: 0;
    box-shadow: none;
    transition: border-color 0.15s;
    border-radius: 2px !important;
    border: 1px solid var(--brand-color-7);
    box-sizing: border-box !important;
    padding-left: 15px !important;
    height: 48px !important;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
    color: #000;
  }

  /deep/ .vdp-datepicker.is-invalid {
    input {
      background-color: #fff0f1;
      border-color: #dc3545 !important;
      color: #dc3545;
    }
  }

  .floating-label {
    position: absolute;
    top: 50%;
    left: 10px;
    padding-left: 7px;
    padding-right: 7px;
    transition: transform 0.1s;
    pointer-events: none;
    transform-origin: 0 100%;
    transform: translateY(-50%);
    &.floatLabel {
      transform: translateY(-135%) scale(0.8);
    }
  }
}
</style>
